import { Component, ReactNode } from "react";
import { AlertTriangle } from "lucide-react";

interface Props { children: ReactNode; }
interface State { hasError: boolean; error: string; }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: "" };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error: error.message };
  }

  componentDidCatch(error: Error) {
    console.error("ErrorBoundary fanget feil:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[300px] flex items-center justify-center">
          <div className="bg-white rounded-2xl border border-danger-border shadow-soft p-8 max-w-md text-center">
            <div className="w-12 h-12 bg-danger-bg rounded-full flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="w-6 h-6 text-danger" />
            </div>
            <h2 className="text-lg font-bold text-ink-900 mb-2">Noe gikk galt</h2>
            <p className="text-sm text-ink-500 mb-4">
              En feil oppstod. Prøv å laste inn siden på nytt.
            </p>
            <p className="text-xs text-ink-400 mb-4 font-mono bg-danger-bg rounded-lg p-2">
              {this.state.error}
            </p>
            <button onClick={() => window.location.reload()}
              className="px-4 py-2.5 rounded-xl text-[13px] font-semibold bg-brand-600 text-white hover:bg-brand-500 transition-all">
              Last inn på nytt
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
